import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import HomePage from './HomePage';
import ServicePage from './ServicePage';
import Layout from './Layout';
import { initGA, trackPageview } from './analytics';

import './App.css';

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageview(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    initGA(); // Initialize Google Analytics on first load
  }, []);

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:id" element={<ServicePage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
